/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import Grid from '@mui/material/Unstable_Grid2';
import { DatePicker } from '@mui/x-date-pickers';
import { toast } from 'react-toastify';
import {
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Typography,
  FormControl,
  MenuItem,
  Select,
} from '@mui/material';
// Components
// CONTEXT
import useProductSamplingv2Context from '../context/useProductSamplingv2Context';
//API
import { postCreatePlan, getCategories } from '../../../api/productSamplingWorkflowApi';

export default function CreateNewPlanModal() {
  const navigate = useNavigate();
  const { newPlan, setNewPlan } = useContext(useProductSamplingv2Context);
  const [categories, setCategories] = useState([]);
  const baseUrl = window.location.origin;
  const defaultForm = {
    title: '',
    month_year: moment().format('YYYY-MM'),
    category_id: 1,
    link: baseUrl,
  };
  const loadCategoryDropdown = async () => {
    const response = await getCategories();
    const { code, data } = response.data;

    if (code === '200') {
      setCategories(data);
    }
  };
  useEffect(() => {
    loadCategoryDropdown();
  }, []);

  const [form, setForm] = useState(defaultForm);

  const handleCancel = () => {
    setNewPlan({ ...newPlan, toggle: false });
  };

  const handleChangeDate = (value) => {
    setForm({ ...form, month_year: moment(value).format('YYYY-MM') });
  };

  const handleChange = (e, name) => {
    setForm({ ...form, [name]: e.target.value });
  };

  const selectedItem = categories.find((item) => item.id === form?.category_id);

  const selectedParent =
    selectedItem?.type === 'parent'
      ? selectedItem
      : categories.find((item) => item.id === selectedItem?.parent_id);

  const bgColor =
    selectedParent?.name === 'Regular'
      ? 'success.main'
      : selectedParent?.name === 'Special'
      ? 'warning.main'
      : 'grey.500';

  const handleSubmit = async () => {
    if (!form.title || form.title === null || form.title === '') {
      toast.warning('Title is required');
      return;
    }

    toast.loading('Processing request please wait...');
    const request = {
      title: form.title,
      month: moment(form.month_year).format('M'),
      year: moment(form.month_year).format('YYYY'),
      category_id: selectedItem?.parent_id,
      sub_category_id: selectedItem.type === 'child' ? selectedItem.child_id : null,
    };

    const response = await postCreatePlan(request);
    const { code, data } = response?.data;

    if (code === '00003') {
      toast.dismiss();
      setForm(defaultForm);
      handleCancel();
      navigate('/maintenance/product-sampling-details?plan_id=' + data?.plan_id + '&type=pm', {
        replace: true,
      });
    }
  };
  return (
    <div>
      <Dialog open={newPlan?.toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
        <DialogTitle>Create New Allocation Plan</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid xs={12} md={12} lg={12}>
              <Box component='form' noValidate autoComplete='off'>
                <TextField
                  variant='outlined'
                  onChange={(e) => handleChange(e, 'title')}
                  name='title'
                  label='Plan Title'
                  fullWidth
                  size='small'
                  value={form?.title}
                />
              </Box>
            </Grid>
            <Grid xs={12} md={12} lg={12}>
              <DatePicker
                label='month_year'
                views={['month', 'year']}
                value={form?.month_year}
                // eslint-disable-next-line react/jsx-props-no-spreading
                renderInput={(params) => (
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  <TextField {...params} label='Effectivity Date' size='small' fullWidth />
                )}
                onChange={(value) => handleChangeDate(value)}
              />
            </Grid>
            <Grid xs={12} md={12} lg={12}>
              <FormControl size='small'>
                <Select
                  value={form?.category_id || ''}
                  onChange={(e) => handleChange(e, 'category_id')}
                  renderValue={(selected) => {
                    const selectedItem = categories.find((item) => item.id === selected);

                    if (!selectedItem) return '';

                    if (selectedItem.type === 'parent') {
                      return selectedItem.name;
                    }

                    const parent = categories.find((item) => item.id === selectedItem.parent_id);

                    return `${parent?.name} - ${selectedItem.name}`;
                  }}
                  sx={{
                    minWidth: 220,
                    height: 28,
                    bgcolor: bgColor,
                    color: '#fff',
                    '& .MuiSelect-select': {
                      py: 0.5,
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 0,
                    },
                    '& .MuiSvgIcon-root': {
                      color: '#fff',
                    },
                  }}
                >
                  {categories
                    .filter((item) => item.type === 'parent')
                    .map((parent) => {
                      const childItems = categories.filter(
                        (item) => item.type === 'child' && item.parent_id === parent.id,
                      );

                      return [
                        <MenuItem key={parent.id} value={parent.id}>
                          {parent.name}
                        </MenuItem>,

                        ...childItems.map((child) => (
                          <MenuItem key={child.id} value={child.id} sx={{ pl: 4 }}>
                            {child.name}
                          </MenuItem>
                        )),
                      ];
                    })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='success' onClick={() => handleSubmit()}>
            Submit
          </Button>
          <Button variant='contained' color='error' onClick={handleCancel}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
